export default __webpack_public_path__ + "static/media/android-logo-only.da04c8be.png";